<template>
	<div class="speed">
		<div v-show="!guideStepFlag">
			<div class="head" @click="backClick">
				<img src="../assets/home/arrow_left.svg" />
				<div>预缓存加速</div>
			</div>
			<div class="content-wrap">
				<div class="tip-text" v-if="tipText">{{ tipText }}</div>
				<div class="line"></div>
				<div class="list-wrap">
					<div
						class="arrow-left arrow"
						@click="arrowLeftClick"
						v-if="list.length > 2"
					></div>
					<div
						class="arrow-right arrow"
						@click="arrowRightClick"
						v-if="list.length > 2"
					></div>
					<div
						:class="{ list: true, nopadding: list.length < 5 }"
						id="list"
					>
						<div
							v-for="(item, index) in list"
							v-bind:key="index"
							class="item"
							:class="tabsClickClass(index)"
							@click="tabsClick(index, item.peerid)"
						>
							<div class="device-bind-wrap">
								<div class="device-status-wrap">
									<div
										:class="{
											'device-icon': true,
											'device-icon-off':
												item.term.status == 1,
										}"
									>
										<!--                    <div :class="{'device-status':true,'device-status-off':item.term.status == 1}">-->
										<!--                      <div v-if="item.term.status == 1">离线</div>-->
										<!--                      <div v-else>在线</div>-->
										<!--                    </div>-->
									</div>
								</div>
								<div class="device-name-wrap">
									<div class="device-name">
										{{
											item.term.name
												? item.term.name
												: item.peerid
										}}
									</div>
									<div
										class="device-ip"
										:class="{
											'device-ip1': item.term.status == 1,
										}"
									>
										IP：{{ $common.ipConvert(item.ip) }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="video-speed-intro-icon"></div>
				<div class="new-wrap">
					<div class="blank-panel"></div>
					<div class="speed-info-wrap">
						<div class="info-title">
							<div></div>
							<div>加速资源缓存路径</div>
						</div>
						<div class="path-wrap">
							<div class="path-text">{{ cachedir }}</div>
						</div>
						<div class="path-tips">暂不支持修改缓存路径</div>
						<div class="info-title">
							<div></div>
							<div>设置缓存大小</div>
						</div>
						<div class="cache-wrap">
							<div
								:class="{
									'cache-btn': true,
									'cache-btn-unactive': cacheBtnFlag == 1,
									'cache-btn-active-middle':
										cacheBtnFlag == 2,
									'cache-btn-active-right': cacheBtnFlag == 3,
								}"
							></div>
							<div class="cache-click-wrap">
								<div @click="cacheLeftClick"></div>
								<div @click="cacheMiddleClick"></div>
								<div @click="cacheRightClick"></div>
							</div>
							<div
								class="cache-line"
								:class="{
									'cache-line-half': cacheBtnFlag == 2,
									'cache-line-full': cacheBtnFlag == 3,
								}"
							></div>
							<div class="cache-text">
								<div>10G</div>
								<div
									style="margin-left: 5px"
									:class="{
										'cache-text-weight': cacheBtnFlag == 2,
									}"
								>
									50G
								</div>
								<div
									:class="{
										'cache-text-weight': cacheBtnFlag == 3,
									}"
								>
									100G
								</div>
							</div>
						</div>
						<div class="warm-text">设置缓存越大，加速效果越好</div>
						<div class="info-title">
							<div></div>
							<div>加速资源</div>
						</div>
						<div class="icon-wrap">
							<div class="icon icon-01"></div>
							<div class="icon icon-02"></div>
							<div class="icon icon-03"></div>
							<div class="icon icon-04"></div>
							<div class="icon icon-05"></div>
							<div class="icon icon-06"></div>
						</div>
						<div class="save-btn" @click="saveClick">保存</div>
						<div class="setting-btns">
							<div
								class="setting-btn"
								@click="showMessageClick('showSetting')"
							>
								<div>设置</div>
							</div>
							<div
								class="setting-btn desc-btn"
								@click="showDescAlert"
							>
								<div>简介</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<SpeedMessageTip
				v-if="messageFlag"
				:cacheused="cacheused"
				:openSpeedFlag="openSpeedFlag"
				:messageType="messageType"
				@clearCacheClick="clearCacheClick"
				@closeMessageAlertClick="closeMessageAlertClick"
				@closeOrOpenSpeedClick="closeOrOpenSpeedClick"
				@cacheCleanClick="cacheCleanClick"
			></SpeedMessageTip>
		</div>
		<div v-show="guideStepFlag == 1" class="guide-wrap">
			<div class="guide-text">
				采用预缓存技术，将热门资源预缓存至本地，当观影或下载时，可就近获取局域网资源，提高上网速度及体验。比如：APP更新、游戏更新、高清视频等。
			</div>
			<div class="guide-change">
				<div class="guide-change-btn1" style="margin-right: 3px"></div>
				<div class="guide-change-btn2"></div>
			</div>
			<div class="guide-bg"></div>
			<div class="guide-btn" @click="speedClick">开启加速</div>
		</div>
		<div v-show="guideStepFlag == 2" class="guide-wrap">
			<div class="guide-text">
				共享带宽存储，将自己NAS的设备中预缓存资源共享给附近节点即可获得积分收益
			</div>
			<div class="guide-change">
				<div class="guide-change-btn2" style="margin-right: 3px"></div>
				<div class="guide-change-btn1"></div>
			</div>
			<div class="guide-bg guide-bg1"></div>
			<div class="guide-btn">开启加速</div>
		</div>
	</div>
</template>
<script>
import * as echarts from "echarts";
import { mapActions } from "vuex";
import SpeedMessageTip from "@/components/SpeedMessageTip.vue";

export default {
	name: "Speed",
	components: {
		SpeedMessageTip,
	},
	data: function () {
		return {
			cacheused: 0, //缓存占用
			cachedir: "", //缓存路径
			tipText: "",
			messageFlag: false, //true显示弹框，false不显示
			messageType: "", //弹框类型：清除缓存弹框（showClearCache）
			currentTab: 0,
			list: [], //设备列表
			peerid: "",
			cacheBtnFlag: null, //1显示左边的缓存按钮，2显示中间的缓存按钮，3显示右边的缓存按钮
			openSpeedFlag: null, //关闭加速1 开启加速0
			guideStepFlag: null, //null不显示视频加速指引，1显示视频加速指引，2显示共享带宽指引
		};
	},
	watch: {
		peerid: function (newVal) {
			let _that = this;
			_that.getlimitget();
		},
	},
	methods: {
		...mapActions([
			"bindget",
			"readguideget",
			"readguideset",
			"limitget",
			"limitset",
			"cacheclean",
		]),
		showDescAlert: function () {
			let _that = this;
			_that.$store.state.view.isShowHcTipsAlert = true;
		},
		backClick: function () {
			let _that = this;
			_that.$router.push({ path: "/home/speedtabs" });
		},
		speedClick: function () {
			let _that = this;
			//已读指引
			// _that.guideStepFlag = 2;

			_that.readguideset([
				function (err, data) {
					_that.guideStepFlag = null;
				},
			]);

			setTimeout(function () {}, 2000);
		},
		showMessageClick: function (messageTypeFlag) {
			let _that = this;
			_that.messageFlag = true;
			_that.messageType = messageTypeFlag;
		},
		cacheCleanClick: function (percent) {
			let _that = this;
			_that.cacheclean([
				_that.peerid,
				percent,
				function (err, data) {
					if (data && data.rtn == 0) {
						_that.tipText = "已清空缓存";
						setTimeout(function () {
							_that.tipText = "";
						}, 2000);
					}
				},
			]);
		},
		closeOrOpenSpeedClick: function (flag) {
			let _that = this;
			let shareSwitch = "on";
			if (flag == 1) {
				shareSwitch = "off";
			}
			_that.limitset([
				_that.peerid,
				null,
				null,
				null,
				shareSwitch,
				function (err, data) {
					if (data && data.rtn == 0) {
						_that.tipText = "已保存";
						setTimeout(function () {
							_that.tipText = "";
						}, 2000);
						_that.getlimitget();
					}
				},
			]);
		},
		clearCacheClick: function () {
			let _that = this;
			_that.messageFlag = false;
			if (_that.openSpeedFlag == 0) {
				_that.tipText = "请关闭加速后再清理缓存";
				setTimeout(function () {
					_that.tipText = "";
				}, 2000);
			} else {
				_that.messageFlag = true;
				_that.messageType = "showClearCache";
			}
		},
		closeMessageAlertClick: function () {
			let _that = this;
			_that.messageFlag = false;
		},
		cacheLeftClick: function () {
			let _that = this;
			_that.cacheBtnFlag = 1;
		},
		cacheMiddleClick: function () {
			let _that = this;
			_that.cacheBtnFlag = 2;
		},
		cacheRightClick: function () {
			let _that = this;
			_that.cacheBtnFlag = 3;
		},

		arrowLeftClick: function () {
			let ele = document.getElementById("list");
			ele.scrollLeft = ele.scrollLeft - 90;
		},
		arrowRightClick: function () {
			let ele = document.getElementById("list");
			ele.scrollLeft = ele.scrollLeft + 90;
		},
		tabsClickClass: function (index) {
			let _that = this;
			return _that.currentTab == index ? "tabsItemActive" : "";
		},
		tabsClick: function (index, peerid) {
			let _that = this;
			_that.currentTab = index;
			_that.peerid = peerid;
		},
		getlimitget: function () {
			let _that = this;
			_that.limitget([
				_that.peerid,
				function (err, data) {
					if (data && data.rtn == 0) {
						if (data.cachedir) {
							_that.cachedir = data.cachedir;
						} else {
							_that.cachedir = "";
						}
						if (data.cacheused) {
							_that.cacheused = data.cacheused;
						} else {
							_that.cacheused = 0;
						}
						//share_switch off关闭 on开启
						if (data.share_switch == "off") {
							_that.openSpeedFlag = 1;
							_that.cacheBtnFlag = null;
						} else {
							_that.openSpeedFlag = 0;
							if (data.diskcache == 100) {
								_that.cacheBtnFlag = 3;
							} else if (data.diskcache == 50) {
								_that.cacheBtnFlag = 2;
							} else {
								_that.cacheBtnFlag = 1;
							}
						}
					}
				},
			]);
		},
		saveClick: function () {
			let _that = this;
			let cacheset = 0;
			if (_that.cacheBtnFlag == 3) {
				cacheset = 100;
			} else if (_that.cacheBtnFlag == 2) {
				cacheset = 50;
			} else {
				cacheset = 10;
			}

			_that.limitset([
				_that.peerid,
				cacheset,
				null,
				0,
				null,
				function (err, data) {
					if (data && data.rtn == 0) {
						_that.tipText = "已保存";
						setTimeout(function () {
							_that.tipText = "";
						}, 2000);

						_that.getlimitget();
					}
				},
			]);
		},
	},
	computed: {},
	mounted() {
		let _that = this;
		_that.bindget([
			function (err, data) {
				if (data && !data.rtn) {
					//rtn等于0时，后台不返回此字段
					if (data && data.terms && data.terms.length > 0) {
						_that.list = data.terms;

						for (
							let index = 0;
							index < _that.list.length;
							index++
						) {
							const element = _that.list[index];
							// 构造ip mac 信息
							element.ip = "";
							element.mac = "";
							if (element.term && element.term.nic) {
								let nic = _that.$common.getNicByNics(
									element.term.nic
								);
								if (nic) {
									element.ip = nic.ipv4n;
									element.mac = nic.mac;
								}
							}
						}

						//默认显示第一个设备的远程服务列表
						_that.peerid = data.terms[0].peerid;

						_that.getlimitget();
					}
				}
			},
		]);

		_that.readguideget([
			function (err, data) {
				if (data && !data.rtn) {
					//rtn等于0时，后台不返回此字段
					// data.read = 0;
					if (data.read == 0) {
						_that.guideStepFlag = 1;
					}
				}
			},
		]);
	},
};
</script>
<style lang="less" scoped>
.speed {
	height: 100%;

	.guide-wrap {
		position: relative;
		margin: 0 auto;
		margin-top: 10px;
		padding-top: 45px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding-right: 10px;
		width: 895px;
		height: 515px;
		border: 1px solid #e4e0c9;
		background-color: #f9fafc;
		box-sizing: border-box;
		border-radius: 3px;
		text-align: center;

		.guide-text {
			width: 680px;
			color: #1a1a1a;
			font-size: 14px;
		}
		.guide-change {
			display: flex;
			margin-top: 28px;
			height: 3px;
			.guide-change-btn1,
			.guide-change-btn2 {
				border-radius: 204px;
				width: 14px;
				height: 100%;
			}
			.guide-change-btn1 {
				background-color: #1f5de3;
			}
			.guide-change-btn2 {
				background-color: rgba(31, 93, 227, 0.2);
			}
		}
		.guide-bg {
			margin-top: 30px;
			width: 733px;
			height: 337px;
			background-image: url("../assets/speed/speed_first.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
			background-position: center;
		}
		.guide-bg1 {
			margin-top: 50px;
			width: 461px;
			height: 290px;
			background-image: url("../assets/speed/speed1.svg");
		}
		.guide-btn {
			position: absolute;
			bottom: 20px;
			left: 325px;
			width: 245px;
			height: 54px;
			line-height: 54px;
			background-color: #1f5de3;
			color: #ffffff;
			font-weight: bold;
			border-radius: 102px;
			cursor: pointer;
		}
	}
	.head {
		display: flex;
		align-items: center;
		width: 915px;
		height: 48px;
		background-color: #e8f5fe;
		font-size: 14px;
		color: #294075;

		img {
			margin-left: 31px;
			margin-right: 3px;
			margin-top: -1px;
			width: 16px;
			height: 13px;
			cursor: pointer;
		}
		div {
			cursor: pointer;
		}
	}
	.content-wrap {
		position: relative;
		padding-right: 10px;
		margin: 0 auto;
		width: 895px;
		height: 475px;
		box-sizing: border-box;
		border: 1px solid #e4e0c9;
		border-top: none;
		border-radius: 3px;
		background-color: #f4f6f9;
		overflow: hidden;

		.tip-text {
			position: absolute;
			top: 200px;
			left: 340px;
			z-index: 10;
			padding-left: 31px;
			padding-right: 31px;
			font-size: 12px;
			color: #f5f5f5;
			background-color: rgba(102, 102, 102, 0.8);
			height: 49px;
			line-height: 49px;
			border-radius: 3px;
		}

		.line {
			position: absolute;
			left: 0;
			top: 0;
			width: 895px;
			height: 2px;
			background-image: url("../assets/speed/line.png");
			background-repeat: no-repeat;
			background-size: 100% 100%;
		}

		.list-wrap {
			margin-left: 10px;
			margin-top: 10px;
			position: relative;
			padding-top: 5px;
			padding-left: 8px;
			padding-right: 8px;
			background-color: #e9f0f7;
			height: 71px;
			width: 475px;
			box-sizing: border-box;
			border-radius: 3px;

			.arrow {
				display: inline-block;
				position: absolute;
				top: 5px;
				z-index: 3;
				width: 20px;
				height: 61px;
				background-color: rgba(251, 253, 255, 1);
				background-size: 10px 17px;
				background-position: center;
				background-repeat: no-repeat;
				cursor: pointer;
			}
			.arrow-left {
				background-image: url("../assets/home/node/arrow_left.png");
				left: 5px;
				box-shadow: 0px 0px 6px 0px rgba(193, 193, 193, 0.3);
			}
			.arrow-right {
				background-image: url("../assets/home/node/arrow_right.png");
				right: 5px;
				box-shadow: 0px 0px 6px 0px rgba(193, 193, 193, 0.3);
			}

			.list {
				padding-right: 17px;
				padding-left: 17px;
				white-space: nowrap;
				overflow-x: scroll;
				overflow-y: hidden;
				height: 61px;
				-ms-overflow-style: none;
				scrollbar-width: none;

				.item {
					position: relative;
					width: 189px;
					height: 61px;
					display: inline-block;
					background-color: #ebebeb;
					border-top-left-radius: 2px;
					box-sizing: border-box;
					cursor: pointer;

					.device-bind-wrap {
						display: flex;
						align-items: center;
						width: 100%;
						height: 100%;
						.device-status-wrap {
							.device-icon {
								position: relative;
								z-index: 2;
								width: 48px;
								height: 48px;
								margin-left: 10px;
								background-image: url("../assets/home/node/device.png");
								background-repeat: no-repeat;
								background-size: 100% 100%;

								.device-status {
									position: absolute;
									bottom: -5px;
									left: 50%;
									transform: translate(-50%, 0);
									width: 31px;
									height: 14px;
									line-height: 14px;
									text-align: center;
									background-color: #1f5de3;
									border-radius: 41px;

									div {
										font-size: 12px;
										color: #f0f0f0;
										transform: scale(0.75);
									}
								}
								.device-status-off {
									background-color: #999999;
								}
							}
							.device-icon-off {
								background-image: url("../assets/home/node/service_device_icon_off.png");
							}
						}

						.device-name-wrap {
							position: relative;
							z-index: 2;
							margin-left: 10px;
							.device-name {
								color: #1c1f28;
								font-size: 14px;
								width: 120px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}
							.device-ip {
								color: #999999;
								font-size: 11px;
								transform: scale(0.8);
								margin-left: -13px;
								padding-left: 12px;
								background-image: url("../assets/speed/speed_device_on.svg");
								background-size: 9px 9px;
								background-repeat: no-repeat;
								background-position: left center;
							}
							.device-ip1 {
								background-image: url("../assets/speed/speed_device_off.svg");
							}
						}
					}
				}

				.item:nth-child(n + 2) {
					padding-left: 1px;
					background-image: url("../assets/home/node/tab_line.png");
					background-size: 1px 52px;
					background-repeat: no-repeat;
					background-position: left center;
				}

				.tabsItemActive {
					background-color: #e8f5fe;
					border: 1px solid rgba(31, 93, 227, 0.12);
					background-image: none !important;
					padding-left: 0px !important;
				}
				.tabsItemActive + .item {
					background-image: none !important;
					padding-left: 0px !important;
				}
			}
			.list::-webkit-scrollbar {
				display: none;
			}
			.nopadding {
				padding-left: 0;
			}
		}

		.video-speed-intro-icon {
			position: absolute;
			bottom: 24px;
			left: 30px;
			width: 435px;
			height: 330px;
			background-image: url(../assets/speed/speed_ad.svg);
			background-size: 100% auto;
			background-repeat: no-repeat;
		}

		.new-wrap {
			/*position: relative;*/
			/*margin-top: -113px;*/
			position: absolute;
			top: -4px;
			right: 10px;

			.blank-panel {
				position: absolute;
				top: 14px;
				width: 385px;
				height: 20px;
				z-index: 9;
				border-top-left-radius: 3px;
				border-top-right-radius: 3px;
			}

			.speed-info-wrap {
				position: relative;
				margin-top: 14px;
				padding-top: 20px;
				background-color: #ffffff;
				width: 385px;
				height: 450px;
				border-radius: 3px;
				box-shadow: 0px 0px 10px 0px rgba(193, 193, 193, 0.3);
				overflow-y: scroll;
				-ms-overflow-style: none;
				scrollbar-width: none;

				.info-title {
					display: flex;
					align-items: center;
					margin-top: 22px;
					margin-left: 41px;
					color: #666666;
					font-size: 14px;
					height: 12px;
					font-weight: bolder;

					div:nth-child(1) {
						margin-right: 5px;
						width: 3px;
						height: 10px;
						border-radius: 20px;
						background-color: #1f5de3;
					}
					div:nth-child(2) {
						margin-top: 0px;
					}
				}
				.path-wrap {
					position: relative;
					margin: 0 auto;
					margin-top: 20px;
					margin-bottom: 8px;
					text-align: left;
					width: 293px;
					height: 27px;
					line-height: 27px;
					background-color: #f5f5f5;
					border-radius: 204px;
					box-sizing: border-box;

					.path-text {
						padding-left: 14px;
						font-size: 12px;
						color: #666666;
					}
					img {
						position: absolute;
						right: 14px;
						top: 5px;
						width: 17px;
						height: 17px;
					}
				}

				.path-tips {
					color: #999999;
					font-size: 12px;
					margin-left: 55px;
				}

				.cache-wrap {
					margin: 0 auto;
					position: relative;
					width: 285px;
					box-sizing: border-box;
					padding-top: 14px;
					margin-top: 20px;

					.cache-btn {
						position: absolute;
						top: 7px;
						width: 20px;
						height: 20px;
						background-size: 100% 100%;
						background-repeat: no-repeat;
						background-position: center;
					}
					.cache-btn-unactive {
						left: 0;
						background-image: url("../assets/speed/speed_info7.png");
					}
					.cache-btn-active-middle {
						left: 132px;
						background-image: url("../assets/speed/speed_info2.png");
					}
					.cache-btn-active-right {
						right: 0;
						background-image: url("../assets/speed/speed_info2.png");
					}

					.cache-click-wrap {
						display: flex;
						justify-content: space-between;
						position: absolute;
						z-index: 9;
						left: 0;
						top: 0;
						width: 285px;
						height: 48px;
						cursor: pointer;
						div {
							width: 100%;
						}
					}

					.cache-line {
						margin: 0 auto;
						width: 265px;
						height: 4px;
						background-image: url("../assets/speed/cache_line.svg");
						background-size: 100% 100%;
						background-repeat: no-repeat;
						background-position: center;
						box-sizing: border-box;
					}
					.cache-line-half {
						background-image: url("../assets/speed/cache_line_half.svg");
					}
					.cache-line-full {
						background-image: url("../assets/speed/cache_line_full.svg");
					}
					.cache-text {
						display: flex;
						margin: 0 auto;
						margin-top: 14px;
						width: 285px;
						align-items: center;
						justify-content: space-between;
						div {
							color: #999999;
							font-size: 12px;
						}
						.cache-text-weight {
							font-weight: bold;
							color: #1f5de3;
						}
					}
				}

				.icon-wrap {
					margin-left: 50px;
					margin-top: 14px;
					.icon {
						display: inline-block;
						width: 36px;
						height: 36px;
						vertical-align: middle;
						background-size: 100% 100%;
						background-repeat: no-repeat;
						margin-right: 15px;
					}
					.icon-01 {
						background-image: url(../assets/speed/share_icon_01.png);
					}
					.icon-02 {
						background-image: url(../assets/speed/share_icon_02.png);
					}
					.icon-03 {
						background-image: url(../assets/speed/share_icon_03.png);
					}
					.icon-04 {
						background-image: url(../assets/speed/share_icon_04.png);
					}
					.icon-05 {
						background-image: url(../assets/speed/share_icon_05.png);
					}
					.icon-06 {
						background-image: url(../assets/speed/share_icon_06.png);
					}
				}

				.warm-text {
					margin-top: 5px;
					margin-left: 49px;
					font-size: 12px;
					color: #999999;
				}
				.save-btn {
					margin: 0 auto;
					margin-top: 40px;
					width: 143px;
					height: 36px;
					line-height: 36px;
					background-color: #215fe4;
					border-radius: 20px;
					color: #f5f5f5;
					font-size: 14px;
					text-align: center;
					cursor: pointer;
					box-shadow: 0px 0px 5px 1px rgba(193, 193, 193, 0.5);
				}
				.save-btn:hover {
					opacity: 0.9;
				}
				.setting-btns {
					text-align: center;
					margin-top: 10px;
				}
				.setting-btn {
					text-align: center;

					text-align: center;
					font-size: 14px;
					color: #999999;
					cursor: pointer;
					display: inline-block;
					margin: 0 5px;

					div {
						border-bottom: 1px solid #999999;
						display: inline-block;
					}
				}
			}
			.speed-info-wrap::-webkit-scrollbar {
				display: none;
			}
		}
	}
}
</style>